import { render, staticRenderFns } from "./custom-filter-table.vue?vue&type=template&id=4071bda6&scoped=true&"
import script from "./custom-filter-table.ts?vue&type=script&lang=ts&"
export * from "./custom-filter-table.ts?vue&type=script&lang=ts&"
import style0 from "./custom-filter-table.scss?vue&type=style&index=0&id=4071bda6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4071bda6",
  null
  
)

export default component.exports